// Baut Report-Links auf talentsheet.aivy.app, so wie integrationControl im
// Backend sie an die ATS schickt. crypt ist nur base64 des Query-Strings,
// keine Signatur: wer den Link hat, sieht den Report.
//
// - Stärkenprofil (TALENTPROFILE) braucht nur die space_id.
// - Passungsprofil (MATCHINGPROFILE, Default-Typ) braucht zusätzlich die
//   career_id. Ohne career_id läuft der PDF-Generator in einen Timeout.

const TALENTSHEET_URLS = {
  develop: 'https://develop.talentsheet.aivy.app',
  staging: 'https://staging.talentsheet.aivy.app',
  production: 'https://talentsheet.aivy.app'
}

export const REPORT_LANGUAGES = ['de', 'en']

export const getTalentsheetUrl = (env) =>
  TALENTSHEET_URLS[env] || TALENTSHEET_URLS.develop

const toCrypt = (params) => {
  const queryString = Object.entries(params)
    .filter(
      ([, value]) => value !== undefined && value !== null && value !== ''
    )
    .map(([key, value]) => `${key}=${value}`)
    .join('&')

  return btoa(`?${queryString}`)
}

export const buildTalentProfileLink = ({ env, spaceId, language }) =>
  `${getTalentsheetUrl(env)}?crypt=${toCrypt({
    space_id: spaceId,
    language,
    type: 'TALENTPROFILE'
  })}`

export const buildMatchingProfileLink = ({
  env,
  spaceId,
  careerId,
  partnerUserId,
  language
}) =>
  `${getTalentsheetUrl(env)}?crypt=${toCrypt({
    career_id: careerId,
    partner_user_id: partnerUserId,
    language,
    space_id: spaceId
  })}`

// Eine eingegebene ID kann Space-ID, User-ID (Owner/Cognito-sub) oder
// Partner-User-ID sein. Die drei Lookups laufen parallel, hier werden die
// Treffer zusammengeführt und je Space vermerkt, worüber er gefunden wurde.
export const mergeSpaceMatches = ({ bySpaceId, byOwner, byPartnerUserId }) => {
  const result = new Map()

  const add = (spaces, via) => {
    for (const space of (spaces || []).filter(Boolean)) {
      const existing = result.get(space.id)
      if (!existing) {
        result.set(space.id, { space, matchedVia: [via] })
      } else if (!existing.matchedVia.includes(via)) {
        existing.matchedVia.push(via)
      }
    }
  }

  add(bySpaceId ? [bySpaceId] : [], 'Space-ID')
  add(byOwner, 'User-ID')
  add(byPartnerUserId, 'Partner-User-ID')

  return [...result.values()].sort((a, b) =>
    (b.space.createdAt || '').localeCompare(a.space.createdAt || '')
  )
}

export const getReportLinks = ({ env, space, careerId, language }) => {
  const reportLanguage = language || space.language || 'de'
  const effectiveCareerId = careerId || space.career_id

  return {
    language: reportLanguage,
    careerId: effectiveCareerId || null,
    talentProfile: buildTalentProfileLink({
      env,
      spaceId: space.id,
      language: reportLanguage
    }),
    matchingProfile: effectiveCareerId
      ? buildMatchingProfileLink({
          env,
          spaceId: space.id,
          careerId: effectiveCareerId,
          partnerUserId: space.partner_user_id,
          language: reportLanguage
        })
      : null
  }
}
